import React from 'react';
import { api, optimisticUpdate } from '@gik/core/api';
import { UI } from '@gik/ui';
import { useUserStore } from '@gik/core/store/UserStore';
import { auth } from '@gik/auth';
import { useWishlistProducts } from '@gik/api/inkinds/wishlistProducts';

interface RemoveFromWishlistButtonProps {
  itemId: number;
  inkindRouteId: string;
  child(onClick: (ev: React.MouseEvent<HTMLElement>) => void): React.ReactElement;
}

export default function RemoveFromWishlistButton({
  itemId,
  inkindRouteId,
  child,
}: RemoveFromWishlistButtonProps): React.ReactElement {
  const wishlistProductUrl = `inkinds/${inkindRouteId}/wishlistProducts/${itemId}`;
  const userStore = useUserStore();
  const userId = userStore.id;

  const { data: wishListProducts, mutate: refreshWishListProducts } = useWishlistProducts(inkindRouteId);

  const onClick = () => {
    if (!wishListProducts) {
      return;
    }
    if (!userId) {
      auth.login();
      return;
    }
    optimisticUpdate(
      wishListProducts.filter(product => product.id !== itemId),
      refreshWishListProducts,
      async () => {
        try {
          await api.delete(wishlistProductUrl);
          UI.notifySuccess('Item successfully removed from wishlist');
        } catch (err) {
          UI.notifyError('Failed to remove item from wishlist');
        }
      }
    );
  };

  return child(onClick);
}
